import React, { Fragment } from "react";
import { Card, Col, Row } from 'react-bootstrap';
import '../../../../styles/diario.scss'


const Est = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.est.nome}</Card.Title>
                        <p>Secretaria: {props.est.secretaria}</p>
                        <p>Função Desempenhada: {props.est.funcao}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Est;